class StickyAnnouncement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.announcement = document.querySelector('.announcement-bar-section');
    this.setAnnouncementHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setAnnouncementHeight.bind(this));
    this.announcement.classList.add('shopify-section-announcement-sticky');
  }

  setAnnouncementHeight() {
    // TODO: 0.5px is a temporary fix for the tiny gap that appears between the announcement and the header
    document.documentElement.style.setProperty('--announcement-height', `${this.announcement.offsetHeight - 0.5}px`);
  }
}

customElements.define('sticky-announcement', StickyAnnouncement);
